import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { VendorEntity } from './vendor.entity';

/**
 * Aggregated mapping of every email address associated with a vendor.
 *
 * Mirrors `vendor_phone` but for emails (DD.12 prereq). The
 * Communications tab needs to find all email_record rows whose
 * from/to/cc match any address belonging to the vendor; this table
 * is the de-normalised source of truth for that join.
 *
 * v1 source of email is `vendor.email` only (one). v2 contributors
 * are `vendor.email` and `vendor_address.email` for each address.
 * Sync keeps the table in lockstep with both whenever either
 * upstream column changes — see `vendorEmailSync.ts`. Addresses are
 * lower-cased to keep an exact-string join cheap regardless of how
 * the user typed them in.
 */
@Index('vendor_email_email_index', ['email'], {})
@Index('vendor_email_pk', ['fkVendorId', 'email'], { unique: true })
@Entity('vendor_email')
export class VendorEmailEntity extends BaseEntity {
	@Column('int', { name: 'fk_vendor__id', unsigned: true })
	public fkVendorId!: number;

	@Column('varchar', { name: 'email', length: 255 })
	public email!: string;

	@ManyToOne(() => VendorEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_vendor__id', referencedColumnName: 'id' }])
	public fkVendor!: VendorEntity;
}
